import * as SVG from 'svg.js';

import { Utils } from 'core/utils';
import { DragInfo, HandleBase, Placement, RoughBox } from './handle.base';

export enum ScaleHandlePosition {
  TopLeft,
  TopCenter,
  TopRight,
  MiddleRight,
  BottomRight,
  BottomCenter,
  BottomLeft,
  MiddleLeft
}

const MOUSE_CURSOR = [];
MOUSE_CURSOR[ScaleHandlePosition.TopLeft] = 'nwse-resize';
MOUSE_CURSOR[ScaleHandlePosition.TopCenter] = 'ns-resize';
MOUSE_CURSOR[ScaleHandlePosition.TopRight] = 'nesw-resize';
MOUSE_CURSOR[ScaleHandlePosition.MiddleRight] = 'ew-resize';
MOUSE_CURSOR[ScaleHandlePosition.BottomLeft] = 'nesw-resize';
MOUSE_CURSOR[ScaleHandlePosition.BottomRight] = 'nwse-resize';
MOUSE_CURSOR[ScaleHandlePosition.BottomCenter] = 'ns-resize';
MOUSE_CURSOR[ScaleHandlePosition.MiddleLeft] = 'ew-resize';

export class ScaleHandle extends HandleBase
{
  private position: ScaleHandlePosition;
  private diameter: number;

  constructor(
      element: SVG.Element,
      position: ScaleHandlePosition,
      handleGroup: SVG.G)
  {
    const stageViewbox = (<any>handleGroup).parents(SVG.Doc).pop().viewbox();
    let stageLongSide = stageViewbox.width > stageViewbox.height ?
        stageViewbox.width : stageViewbox.height;
    if (Utils.isSmallDevice()) {
      stageLongSide *= 2;
    }

    const diameter = stageLongSide / 45;

    super(
        element,
        handleGroup.circle(diameter)
          .fill('white')
          .stroke({ width: stageLongSide / 500 })
          .addClass('handle-scale-control')
          .style('cursor', MOUSE_CURSOR[position]));

    this.diameter = diameter;
    this.position = position;
  }

  public dragEnd(): void
  {
    const relevantRotation =
        (<any>this.element).parent().transform().rotation % 360;
    let cursorPosition = this.position + Math.round(relevantRotation / 45);
    if (cursorPosition < 0) {
      cursorPosition += MOUSE_CURSOR.length - 1;
    }
    if (cursorPosition > MOUSE_CURSOR.length - 1) {
      cursorPosition -= MOUSE_CURSOR.length;
    }
    this.control.style('cursor', MOUSE_CURSOR[cursorPosition]);
  }

  protected updateControl(bounds: RoughBox): void {
    switch (this.position) {
      case ScaleHandlePosition.TopLeft:
        this.roughCenter(this.control,
                         bounds.x,
                         bounds.y,
                         this.diameter,
                         this.diameter);
        break;
      case ScaleHandlePosition.TopCenter:
        this.roughCenter(this.control,
                         bounds.x + bounds.width / 2,
                         bounds.y,
                         this.diameter,
                         this.diameter);
        break;
      case ScaleHandlePosition.TopRight:
        this.roughCenter(this.control,
                         bounds.x + bounds.width,
                         bounds.y,
                         this.diameter,
                         this.diameter);
        break;
      case ScaleHandlePosition.MiddleRight:
        this.roughCenter(this.control,
                         bounds.x + bounds.width,
                         bounds.y + bounds.height / 2,
                         this.diameter,
                         this.diameter);
        break;
      case ScaleHandlePosition.BottomLeft:
        this.roughCenter(this.control,
                         bounds.x,
                         bounds.y + bounds.height,
                         this.diameter,
                         this.diameter);
        break;
      case ScaleHandlePosition.BottomCenter:
        this.roughCenter(this.control,
                         bounds.x + bounds.width / 2,
                         bounds.y + bounds.height,
                         this.diameter,
                         this.diameter);
        break;
      case ScaleHandlePosition.BottomRight:
        this.roughCenter(this.control,
                         bounds.x + bounds.width,
                         bounds.y + bounds.height,
                         this.diameter,
                         this.diameter);
        break;
      case ScaleHandlePosition.MiddleLeft:
        this.roughCenter(this.control,
                         bounds.x,
                         bounds.y + bounds.height / 2,
                         this.diameter,
                         this.diameter);
        break;
      default: // won't be reached
    }
  }

  protected drag(info: DragInfo): Placement {
    switch (this.position) {
      case ScaleHandlePosition.TopLeft: {
        return {
          x: info.reference.x + info.delta.x,
          y: info.reference.y + info.delta.y,
          width: info.reference.width - info.delta.x,
          height: info.reference.height - info.delta.y,
        };
      }
      case ScaleHandlePosition.TopCenter: {
        return {
          y: info.reference.y + info.delta.y,
          height: info.reference.height - info.delta.y,
        };
      }
      case ScaleHandlePosition.TopRight: {
        return {
          y: info.reference.y + info.delta.y,
          width: info.reference.width + info.delta.x,
          height: info.reference.height - info.delta.y,
        };
      }
      case ScaleHandlePosition.MiddleRight: {
        return {
          width: info.reference.width + info.delta.x,
        };
      }
      case ScaleHandlePosition.BottomLeft: {
        return {
          x: info.reference.x + info.delta.x,
          width: info.reference.width - info.delta.x,
          height: info.reference.height + info.delta.y,
        };
      }
      case ScaleHandlePosition.BottomCenter: {
        return {
          height: info.reference.height + info.delta.y,
        };
      }
      case ScaleHandlePosition.BottomRight: {
        return {
          width: info.reference.width + info.delta.x,
          height: info.reference.height + info.delta.y,
        };
      }
      case ScaleHandlePosition.MiddleLeft: {
        return {
          x: info.reference.x + info.delta.x,
          width: info.reference.width - info.delta.x
        };
      }
      default:
        // won't be reached
        return {};
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/controls/transform-handle/handle.scale.ts